export default{
	name : 'residence_dialog',
	props:{
		show : Boolean
	},
	data () {
		return {}
	},
	methods : {
		close() {
			this.$emit('close');
		},
		jzzbl() {
			window.location.href = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx87d8c164f712db08&redirect_uri=https%3a%2f%2fm.cs96111.com%2f96111%2fwechat%2foauth%3fscope%3duserid%26redirect%3dpolice.jzz%26type%3dnone&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect";
		},
		jzzsb() {
			window.location.href = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx87d8c164f712db08&redirect_uri=https%3a%2f%2fm.cs96111.com%2f96111%2fwechat%2foauth%3fscope%3duserid%26redirect%3dpolice.jzzsb%26type%3dnone&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect";
		},
		more() {
			this.$router.push('/micro_police')
		}
	}
}


// WEBPACK FOOTER //
// ./src/components/residence_dialog/residence_dialog.controller.js